module.exports = __webpack_public_path__ + "vi.svg?d81c1ed35a04e6565d332922550c96b7";